enum NewsletterActions {
  FETCH_LIST = "newsletterFetchList",
  REFRESH_LIST = "newsletterRefreshList",
  GET_CAMPAIGN = "newsletterGetCampaign",
  CREATE_CAMPAIGN = "newsletterCreateCampaign",
  UPDATE_CAMPAIGN = "newsletterUpdateCampaign",
  DELETE_CAMPAIGN = "newsletterDeleteCampaign",
  CANCEL_CAMPAIGN = "newsletterCancelCampaign",
  SCHEDULE_CAMPAIGN = "newsletterScheduleCampaign",
  AUDIENCE_PREVIEW = "newsletterAudiencePreview",
  FETCH_STATS = "newsletterFetchStats",
  COMPILE_CAMPAIGN = "newsletterCompileCampaign",
  PREVIEW_CAMPAIGN = "newsletterPreviewCampaign",
  SEND_TEST_MAIL = "newsletterSendTestMail",
  FETCH_AVAILABLE_BLOCKS = "newsletterFetchAvailableBlocks",
  FETCH_AVAILABLE_BLOGS = "newsletterFetchAvailableBlogs",
  FETCH_AVAILABLE_BENEFITS = "newsletterFetchAvailableBenefits",
  FETCH_SETTINGS = "newsletterFetchSettings",
  UPDATE_SETTINGS = "newsletterUpdateSettings",
  TEST_CONNECTION = "newsletterTestConnection",
  FETCH_SNIPPETS = "newsletterFetchSnippets",
  GET_SNIPPET = "newsletterGetSnippet",
  CREATE_SNIPPET = "newsletterCreateSnippet",
  UPDATE_SNIPPET = "newsletterUpdateSnippet",
  DELETE_SNIPPET = "newsletterDeleteSnippet",
}

enum NewsletterMutation {
  SET_RENDER_UPDATE = "newsletterListRenderNeeded",
  SET_LIST_RESULT = "newsletterListResult",
  SET_SETTINGS_RESULT = "newsletterSettingsResult",
  SET_SNIPPETS_RESULT = "newsletterSnippetsResult",
}

export { NewsletterActions, NewsletterMutation };
